import { ZonedDate } from '@eika-infrastruktur/date';

import type { AccountNumber } from '../../../../generated-types';

export enum SetAccountType {
    SET_FROM_ACCOUNT = 'SET_FROM_ACCOUNT',
    SET_TO_ACCOUNT = 'SET_TO_ACCOUNT',
}

export type SetAccount = {
    setAccountType: SetAccountType;
    accountNumber: AccountNumber;
};

export enum TransferActionType {
    ACCOUNT_SELECTED = 'ACCOUNT_SELECTED',
    AMOUNT = 'AMOUNT',
    NOTE = 'NOTE',
    OWN_TEXT = 'OWN_TEXT',
    TRANSFER_DATE = 'TRANSFER_DATE',
    SHOW_FROM_ACCOUNTS = 'SHOW_FROM_ACCOUNTS',
    HIDE_FROM_ACCOUNTS = 'HIDE_FROM_ACCOUNTS',
    SHOW_TO_ACCOUNTS = 'SHOW_TO_ACCOUNTS',
    HIDE_TO_ACCOUNTS = 'HIDE_TO_ACCOUNTS',
    RESET = 'RESET',
    RESET_WITH_FROM_ACCOUNT = 'RESET_WITH_FROM_ACCOUNT',
    RESET_ERROR = 'RESET_ERROR',
}

export type TransferAction =
    | { type: TransferActionType.ACCOUNT_SELECTED; payload: SetAccount }
    | { type: TransferActionType.SHOW_FROM_ACCOUNTS }
    | { type: TransferActionType.HIDE_FROM_ACCOUNTS }
    | { type: TransferActionType.SHOW_TO_ACCOUNTS }
    | { type: TransferActionType.HIDE_TO_ACCOUNTS }
    | { type: TransferActionType.AMOUNT; payload?: number }
    | { type: TransferActionType.NOTE; payload: string }
    | { type: TransferActionType.OWN_TEXT; payload?: string }
    | { type: TransferActionType.TRANSFER_DATE; payload?: ZonedDate }
    | { type: TransferActionType.RESET }
    | { type: TransferActionType.RESET_WITH_FROM_ACCOUNT; payload?: AccountNumber }
    | { type: TransferActionType.RESET_ERROR };
